// 解决 ResizeObserver 警告问题
export function fixResizeObserverWarning() {
  // 忽略 ResizeObserver 错误
  const resizeObserverErr = window.ResizeObserver;
  if (resizeObserverErr) {
    const originalResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class ResizeObserver extends originalResizeObserver {
      constructor(callback) {
        super(entries => {
          try {
            callback(entries);
          } catch (error) {
            if (error.message !== 'ResizeObserver loop completed with undelivered notifications.') {
              console.error('ResizeObserver error:', error);
            }
          }
        });
      }
    };
  }
}

// 防抖函数
export function debounce(func, wait, immediate) {
  let timeout;
  return function() {
    const context = this, args = arguments;
    const later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}